import { render, staticRenderFns } from "./customerOrder.vue?vue&type=template&id=bf0c4ebc&scoped=true"
import script from "./customerOrder.vue?vue&type=script&lang=js"
export * from "./customerOrder.vue?vue&type=script&lang=js"
import style0 from "./customerOrder.vue?vue&type=style&index=0&id=bf0c4ebc&prod&scoped=true&lang=css"
import style1 from "./customerOrder.vue?vue&type=style&index=1&id=bf0c4ebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0c4ebc",
  null
  
)

export default component.exports